

  export default {
    props: {
      tree: Object,
      abstract: Object
    }
  }

